import type { Order } from "../../../../../../../services";

const cellProcessing = (item: Order.Model["phones"]) =>
	[...(item ?? [])].sort((a, b) => (a.group ?? 0) - (b.group ?? 0))?.[1]
		?.number ?? "";

export default cellProcessing;
